import { Box, Text } from '@chakra-ui/react';
import { usePreview } from 'react-dnd-preview';
import { FOLDER_DRAG_EVENT_TYPE } from 'app/components/SideBar/SongFolder/constants';
import { PIN_DRAG_EVENT_TYPE } from 'app/components/PinnedSongsSection/constants';
import { getDragPreviewSubTitle } from './utils';

export const DragPreview = () => {
  const preview = usePreview<
    {
      guid?: string;
      label: string;
      itemType: string;
      songGuids: string[];
    },
    HTMLDivElement
  >({ placement: 'left' });
  if (
    !preview.display ||
    preview.itemType === 'ROW_DRAG' ||
    preview.itemType === FOLDER_DRAG_EVENT_TYPE
  ) {
    return null;
  }
  const { item, style, ref } = preview;
  const songGuids =
    preview.itemType === PIN_DRAG_EVENT_TYPE ? [item.guid!] : item.songGuids;
  return (
    <Box
      ref={ref}
      sx={{
        bg: 'black',
        p: 2,
        maxW: 200,
        borderRadius: '4px',
        mt: -2,
        ml: 2,
        zIndex: 1,
        ...style,
      }}
    >
      {songGuids?.length < 2 && (
        <Text
          color="white"
          sx={{
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          }}
        >
          {item.label}
        </Text>
      )}
      {songGuids?.length > 1 && (
        <Text color="white">{getDragPreviewSubTitle(songGuids)}</Text>
      )}
    </Box>
  );
};
